export default __webpack_public_path__ + "static/jasmine-a3416e0c658b574a2248903c31a648e3.webp";